import { useState, useRef } from "react";
import { useSiteLanguage } from "../../context/useSiteLanguage";

const LANGS = [
    { code: "en", label: "English", abbr: "EN" },
    { code: "te", label: "Telugu", abbr: "TE" },
    { code: "hi", label: "Hindi", abbr: "HI" },
    { code: "ta", label: "Tamil", abbr: "TA" },
    { code: "kn", label: "Kannada", abbr: "KN" },
];

export default function SiteLanguageSelector() {
    const [open, setOpen] = useState(false);
    const buttonRef = useRef(null);
    const { lang, setLang } = useSiteLanguage();

    const handleSelect = (code) => {
        setLang(code);
        setOpen(false);
    };

    const current = LANGS.find((l) => l.code === lang) || LANGS[0];

    return (
        <div className="relative" ref={buttonRef}>
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                className="text-sm px-3 py-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition text-white flex items-center gap-2"
                title={`Language: ${current.label}`}
            >
                <span className="font-semibold text-xs">{current.label}</span>
                <svg className="w-3 h-3 text-white/70" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" />
                </svg>
            </button>

            {open && (
                <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded shadow-md z-50 text-gray-800">
                    {LANGS.map((l) => (
                        <button
                            key={l.code}
                            onClick={() => handleSelect(l.code)}
                            className="w-full text-left px-3 py-2 hover:bg-gray-50 text-sm text-gray-800"
                        >
                            {l.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
